/**
 * Helpers for ServiceClient responses that resolve with axios error objects instead of rejecting.
 */

export const isApiError = (response: unknown): boolean => {
  if (!response || typeof response !== "object") {
    return false;
  }

  const err = response as Record<string, unknown>;

  if (err.code === "ERR_BAD_RESPONSE" || err.code === "ERR_NETWORK") {
    return true;
  }

  const status = (err.response as { status?: number } | undefined)?.status;
  if (typeof status === "number" && status >= 400) {
    return true;
  }

  if (typeof err.status === "number" && err.status >= 400) {
    return true;
  }

  return false;
};

export const getApiErrorMessage = (response: unknown): string => {
  if (!response || typeof response !== "object") {
    return "An unexpected error occurred";
  }

  const err = response as Record<string, unknown>;
  const data = (err.response as { data?: Record<string, unknown> } | undefined)?.data;

  if (typeof data?.Message === "string" && data.Message.trim()) {
    return data.Message;
  }

  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message;
  }

  if (typeof data?.title === "string" && data.title.trim()) {
    return data.title;
  }

  if (typeof err.message === "string" && err.message.trim()) {
    return err.message;
  }

  return "An unexpected error occurred";
};

export const getApiErrorStatus = (response: unknown): number | undefined => {
  if (!response || typeof response !== "object") {
    return undefined;
  }

  const err = response as Record<string, unknown>;
  const status = (err.response as { status?: number } | undefined)?.status;

  if (typeof status === "number") {
    return status;
  }

  if (typeof err.status === "number") {
    return err.status;
  }

  return undefined;
};
